import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Device from './Device';

class DeviceList extends Component {
    static propTypes = {
        className: PropTypes.string,
        devices: PropTypes.array,
        onDrop: PropTypes.func,
        children: PropTypes.array
    };

    getDevices = () => {
        let devices = [];
        this.props.devices.forEach((v) => {
            devices.push(<Device key={v} deviceId={v} />);
        });
        return devices;
    };

    onDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
    };

    onDrop = (e) => {
        e.preventDefault();
        if (this.props.onDrop) {
            this.props.onDrop(e);
        }
    };

    render() {
        return (
            <div
                className={'device-list ' + this.props.className}
                onDragOver={(e) => this.onDragOver(e)}
                onDrop={(e) => {
                    this.onDrop(e);
                }}
            >
                {this.getDevices()}
                {this.props.children}
            </div>
        );
    }
}

export default DeviceList;
